import ContentContainer from "../components/ContentContainer";

function App() {
  return (
    <>
      <ContentContainer />
    </>
  );
}

export default App;
